import React, { useEffect, useRef, useState } from 'react'

import DataContextProvider from './DataContext'
import Panel from '../../../elem/panel/Panel'
import { aggregatePanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import AggregateHeader from './AggregateHeader'
import ResetDropdown from './ResetDropDown'
import ParamDropdown from './ParamDropdown'
import AggregateChart from './AggregateChart'

export default ({ width, name }) => {
    const chartHeaderRef = useRef(null)
    const [headerHeight, setHeaderHeight] = useState(0)

    useEffect(() => {
        if (!chartHeaderRef.current) return

        const updateHeaderHeight = () => {
            setHeaderHeight(
                (chartHeaderRef.current &&
                    chartHeaderRef.current.offsetHeight) ||
                    0
            )
        }

        updateHeaderHeight()

        const resizeObserver = new ResizeObserver(updateHeaderHeight)
        resizeObserver.observe(chartHeaderRef.current)

        return () => {
            if (chartHeaderRef.current) {
                resizeObserver.unobserve(chartHeaderRef.current)
            }
        }
    }, [])

    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
            <div className="explorerWrapper">
                <DataContextProvider>
                    <AggregateHeader />
                    <div ref={chartHeaderRef}>
                        <ResetDropdown />
                        <ParamDropdown />
                    </div>
                    <AggregateChart name={name} headerHeight={headerHeight} />
                </DataContextProvider>
            </div>
        </Panel>
    )
}
